import { request } from "#/utils/request";

export interface MaintenanceData {
  emManutencao: boolean;
  mensagemHorario: string;
}

export const getMaintenance = async (): Promise<MaintenanceData> => {
  const maintenance = await request.get<MaintenanceData>("/maintenance");

  return maintenance.data;
};
